<template>
    <div>
        <el-row :gutter="30">
            <el-col :xs="24" :xl="16">
				<el-form-item prop="buyType"  :rules="[{required: true, message: `请选择证件绑定时机`}]" >
					<!-- 权益票：绑定前置票后，证件绑定时机跟随主票设置，不可更改 -->
					<el-radio-group v-model="formData.buyType" size="medium"  :disabled="channelName && channelName != 'showstart' || (formData.groupId == 3 && formData.mainPriceId)">
						<el-radio :label="0" :disabled="formData.ticketType == 5 ">无须绑定</el-radio>
						<el-radio :label="2">购票时要求绑定</el-radio>
						<!-- 权益票不支持「先购票后再绑定」 -->
						<el-radio :label="3" :disabled="formData.ticketType == 2 || formData.ticketType == 4 || formData.groupId == 3">先购票后再绑定</el-radio>
					</el-radio-group>
				</el-form-item>	
                <!-- <el-card shadow="never">
                    <el-row :gutter="30">
                        <el-col :span="24"  >
                            						
                        </el-col>
                    </el-row>					
                </el-card> -->
            </el-col>
        </el-row>

    </div>
</template>

<script>
export default {
    props:{
        formData: {
            type: Object,
            default: null
        },
		channelName:{
			type:[Number,String],
			default:''
		}
    },
    watch:{
        'formData.ticketType'(v){
            if( v == 2 || v == 4 ){
                this.formData.buyType = 2
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.el-card{
    margin-bottom: 20px;
}
</style>